// @flow
import React, { useEffect, useState } from 'react';
import { useAuth } from '../hooks';
import { Client } from '../prismic-configuration';
import UserLogin from '../components/profile/UserLogin';
import { PageWrapper } from '../components/base';
import { Account } from '../components/account';
import { PrismicAccount, PrismicAward } from '../types/prismic';

const ProfilePage = () => {
  const { user } = useAuth();
  const [content, setContent] = useState(null);
  const [award2025, setAward2025] = useState(null);
  const [award2023Sephora, setAward2023Sephora] = useState(null);

  useEffect(() => {
    loadCopy();
  }, []);

  const loadCopy = async () => {
    const client = Client();
    const account: PrismicAccount = await client.getSingle('account', {});
    const award: PrismicAward = await client.getByUID(
      'award',
      'award2023_achievement',
      {}
    );
    const awardSephora: PrismicAward = await client.getByUID(
      'award',
      'award2023_sephora',
      {}
    );

    account.data = Object.assign(account.data, {
      award_process_active: award.data.award_process_active,
    });
    setAward2025(award);
    setAward2023Sephora(awardSephora);
    setContent(account);
  };

  if (!user) {
    return (
      <PageWrapper title="Sign In">
        <section className="full-height inner-width inner-width-padding column center">
          <h4>You need to be signed in to view this page</h4>
          <UserLogin />
        </section>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper title="Account">
      <Account
        user={user}
        content={content}
        award2025={award2025}
        award2023Sephora={award2023Sephora}
      />
    </PageWrapper>
  );
};

export default ProfilePage;
